var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meter"},_vm._l((_vm.meterLevels),function(level,idx){return _c('div',{key:idx,staticClass:"meter-channel",style:({ '--level': level })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }